import { createApp } from 'vue'
import App from './App.vue'
import mitt from 'mitt';
import { createRouterInstance } from './router'
import store from './store'

// import external CSS
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import './main.css'

// Emetteur permettant la communication entre des composant sans relation (principalement pour formPL)
const emitter = mitt();

// Vue Main Init
const app = createApp(App);

app.config.globalProperties.emitter = emitter;

const router = createRouterInstance(app, store);

app.use(store).use(router).mount('#app');


